import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/beverage-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import beverage from '../../json/beverage-disposal-data.json'

const beverageServiceData = {
  name: 'Beverage Disposal and Recycling',
  description:
    'Sustainable beverage disposal and recycling for expired and surplus product nationwide. Dimension handles sugary drinks, alcoholic beverages, and milk and dairy, routing them to certified facilities for ethanol reclamation with full documentation.',
  serviceType: 'Beverage Disposal and Recycling',
  url: 'https://getdimension.com/beverage-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Sugary Beverage Recycling' },
    { name: 'Alcoholic Beverage Disposal' },
    { name: 'Milk and Dairy Disposal' },
    { name: 'Expired Inventory Removal' },
    { name: 'Ethanol Reclamation' },
  ],
}

const beverageFAQData = {
  questions: beverage.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function BeverageDisposal() {
  return (
    <>
      <Head>
        <title>Beverage Disposal &amp; Recycling Services | Dimension</title>
        <meta
          name="description"
          content="Sustainable beverage disposal and recycling nationwide. Dimension removes expired sodas, alcohol, and dairy, reclaims the ethanol, and provides full documentation. Cased pricing from ~$0.83/case."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/beverage-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={beverageServiceData} />
        <SchemaMarkup type="FAQPage" data={beverageFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="beverage"
          heading={beverage.pitch.heading}
          material={beverage.pitch.material}
          pitchText={beverage.pitch.pitchText}
          ctaLink={beverage.pitch.ctaLink}
          ctaText={beverage.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...beverage.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...beverage.benefits} />
        <Approach {...beverage.approach} />
        <FAQ {...beverage.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Alcoholic Beverage Disposal',
              href: '/alcoholic-beverage-disposal',
              description:
                'Compliant destruction and recycling of beer, wine, spirits, and other alcoholic beverages.',
            },
            {
              label: 'Sugary Beverage Disposal',
              href: '/sugary-beverage-disposal',
              description:
                'Recycling of expired sodas, juices, and energy drinks through ethanol reclamation.',
            },
            {
              label: 'Milk and Dairy Disposal',
              href: '/milk-dairy-disposal',
              description:
                'Sustainable disposal of expired milk, yogurt, and dairy drinks with carton recycling.',
            },
            {
              label: 'Industrial Alcohol Disposal',
              href: '/industrial-alcohol-disposal',
              description:
                'Reclamation of spent ethanol, isopropyl alcohol, and methanol, with rebates for high-quality material.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default BeverageDisposal
